export const addTemplates = (subjectTemplate) => ({
  type: "ADD_TEMPLATES",
  payload: subjectTemplate,
})

export const noop = () => {}
